import { Routes } from '@angular/router';
import { authGuard, guestGuard, setPasswordGuard } from './core/guards';

const soon = (title: string) => ({
  loadComponent: () => import('./pages/coming-soon').then((m) => m.LoopComingSoonPage),
  data: { title },
});

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'overview' },
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () => import('./pages/login').then((m) => m.LoopLoginPage),
  },
  {
    path: 'set-password',
    canActivate: [setPasswordGuard],
    loadComponent: () => import('./pages/set-password').then((m) => m.LoopSetPasswordPage),
  },
  {
    path: 'acting',
    loadComponent: () => import('./pages/acting').then((m) => m.LoopActingPage),
  },
  {
    path: 'no-access',
    loadComponent: () => import('./pages/no-access').then((m) => m.LoopNoAccessPage),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./shell/loop-shell').then((m) => m.LoopShell),
    children: [
      {
        path: 'setup',
        loadComponent: () => import('./pages/setup').then((m) => m.LoopSetupPage),
      },
      {
        path: 'overview',
        loadComponent: () => import('./pages/overview').then((m) => m.LoopOverviewPage),
      },
      {
        path: 'insights',
        loadComponent: () => import('./pages/insights').then((m) => m.LoopInsightsPage),
      },
      {
        path: 'insights/:id',
        loadComponent: () =>
          import('./pages/insight-detail').then((m) => m.LoopInsightDetailPage),
      },
      {
        path: 'customers',
        loadComponent: () => import('./pages/customers').then((m) => m.LoopCustomersPage),
      },
      {
        path: 'loyalty',
        loadComponent: () => import('./pages/loyalty').then((m) => m.LoopLoyaltyPage),
      },
      {
        path: 'campaigns',
        loadComponent: () => import('./pages/campaigns').then((m) => m.LoopCampaignsPage),
      },
      {
        path: 'auto-campaigns',
        loadComponent: () =>
          import('./pages/auto-campaigns').then((m) => m.LoopAutoCampaignsPage),
      },
      {
        path: 'feedback',
        loadComponent: () => import('./pages/feedback').then((m) => m.LoopFeedbackPage),
      },
      { path: 'qr', ...soon('QR Code') },
      {
        path: 'referrals',
        loadComponent: () => import('./pages/referrals').then((m) => m.LoopReferralsPage),
      },
      { path: 'membership', loadComponent: () => import('./pages/membership').then((m) => m.LoopMembershipPage) },
      { path: 'whatsapp', ...soon('WhatsApp Chat') },
    ],
  },
  { path: '**', redirectTo: 'overview' },
];
